(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const track = document.querySelector('.testimonial-track');
    const products = document.querySelectorAll('.testimonial-card');
    const prevBtn = document.querySelector('.testimonial-prev');
    const nextBtn = document.querySelector('.testimonial-next');

    function getVisibleCount() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    if (window.innerWidth <= 1024) return 3;
    return parseInt(track.dataset.visibleCount) || 4;
  }
    const totalProducts = parseInt(track.dataset.totalProducts);
    const total = products.length;
    console.log(total);
    let index = 0;

    function updateSlider() {
      const visibleCount = getVisibleCount();
      const offset = -(index * (100 / visibleCount));
      track.style.transform = `translateX(${offset}%)`;
    }

    nextBtn.addEventListener('click', () => {
      const visibleCount = getVisibleCount();
      if (index < totalProducts - visibleCount) {
        index++;
      } else {
        // Si llega al final, vuelve al inicio
        index = 0;
      }
      updateSlider();
    });

    prevBtn.addEventListener('click', () => {
      const visibleCount = getVisibleCount();
      if (index > 0) {
        index--;
      } else {
        // Si está al inicio y retrocede, va al final
        index = total - visibleCount;
      }
      updateSlider();
    });
    // --- Soporte para gestos táctiles ---
let startX = 0;
let endX = 0;

track.addEventListener('touchstart', (e) => {
  startX = e.touches[0].clientX;
});

track.addEventListener('touchmove', (e) => {
  endX = e.touches[0].clientX;
});

track.addEventListener('touchend', () => {
  const diff = startX - endX;
const visibleCount = getVisibleCount();
  // Define un umbral para evitar falsos positivos
  if (Math.abs(diff) > 50) {
    if (diff > 0) {
      // Swipe izquierda → siguiente
      if (index < totalProducts - visibleCount) {
        index++;
      } else {
        index = 0;
      }
    } else {
      // Swipe derecha → anterior
      if (index > 0) {
        index--;
      } else {
        index = total - visibleCount;
      }
    }
    updateSlider();
  }
});

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-menu"] && !Shopify.designMode) return;
  try {
    
  // La dirección la pinta masca-estado.js, que es la fuente de verdad. Acá solo
  // le pedimos que repinte por si esta sección se montó despues de su primera
  // pasada (Shopify inyecta el bundle de  javascript  en otro momento).
  document.addEventListener('DOMContentLoaded', () => {
    if (window.MascaEstado) window.MascaEstado.pintar();
  });
  window.addEventListener('masca:estado', () => {
    if (window.MascaEstado) window.MascaEstado.pintar();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-pets"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tab-btn').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.tab-btn').forEach((btn) => btn.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach((content) => content.classList.remove('active'));
      button.classList.add('active');
      document.getElementById(button.dataset.tab).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
